// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"clinical-portal-3__VoicePstnFallback__wrapper","button":"clinical-portal-3__VoicePstnFallback__button"};